/* Seyasha motion layer: scroll reveal, banner carousel extras, header state. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && Shopify.designMode);
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  function header() {
    var on = false;
    function f() { var s = window.scrollY > 12; if (s !== on) { on = s; root.classList.toggle('sy-scrolled', s); } }
    window.addEventListener('scroll', f, { passive: true }); f();
  }

  function heroes() {
    $$('[data-sy-hero]').forEach(function (h) {
      if (h.dataset.sy5) return; h.dataset.sy5 = '1';
      var track = h.querySelector('.sy-hero__track'), slides = $$('.sy-slide', h);
      if (!track || !slides.length) return;
      h.style.setProperty('--sp', (parseInt(h.dataset.speed, 10) || 5) + 's');
      function cur() { var m = /-(\d+)%/.exec(track.style.transform || ''); return m ? Math.round(+m[1] / 100) : 0; }
      function mark() { var i = cur(); slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); }); }
      mark();
      if ('MutationObserver' in window) new MutationObserver(mark).observe(track, { attributes: true, attributeFilter: ['style'] });
      $$('[data-sy-prev],[data-sy-next]', h).forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          if (typeof h.syGo === 'function') h.syGo(cur() + (b.hasAttribute('data-sy-next') ? 1 : -1), true);
        });
      });
    });
  }

  function reveal() {
    if (reduced || design || !('IntersectionObserver' in window)) return;
    root.classList.add('sy-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var sel = '.sy-sec__h,.sy-rail,.sy-usp>li,.sy-circle,.sy-mq,.newsletter__wrapper,.rich-text__blocks,.product-grid>li,.sy-drops>a,.sy-bundle,[id$="__sy_banner"] .banner,.related-products__heading';
    $$(sel).forEach(function (el) {
      if (el.classList.contains('sy-rv')) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return; /* already on screen: leave it alone */
      var k = 0, p = el.previousElementSibling;
      while (p && k < 5) { k++; p = p.previousElementSibling; }
      if (el.matches('.sy-usp>li,.sy-circle,.product-grid>li,.sy-drops>a')) el.style.setProperty('--d', (k % 4) * 80 + 'ms');
      el.classList.add('sy-rv');
      io.observe(el);
    });
    /* safety net: never leave anything hidden */
    setTimeout(function () { $$('.sy-rv:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in'); }); }, 2500);
  }

  function init() { header(); heroes(); reveal(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function () { heroes(); });
})();
